import { jsx } from 'react/jsx-runtime';
import { createContext, useReducer, useContext } from 'react';
import { retryReducer } from '../reducers/payment-retry/retry-data.js';
import { RetryActions } from '../reducers/payment-retry/types.js';

const RetryDataContext = createContext({
    retryState: {
        retryData: undefined,
        initiatePaymentData: undefined,
        processAuthorisationData: undefined,
        customerId: undefined,
    },
    retrySuccessWithData: () => null,
    initiateRetryPaymentStart: () => null,
    initiateRetryPaymentFailure: () => null,
    initiateRetryPaymentSuccess: () => null,
    processPaymentAuthorisationStart: () => null,
    processPaymentAuthorisationFailure: () => null,
    processPaymentAuthorisationSuccess: () => null,
});
const RetryDataProvider = ({ children, customerId }) => {
    const [state, dispatch] = useReducer(retryReducer, {
        retryData: undefined,
        initiatePaymentData: undefined,
        processAuthorisationData: undefined,
        customerId,
    });
    const retrySuccessWithData = (retryData) => {
        dispatch({ type: RetryActions.retry_fetch_success, payload: retryData });
    };
    const initiateRetryPaymentStart = () => {
        dispatch({ type: RetryActions.initiate_payment_start });
    };
    const initiateRetryPaymentFailure = () => {
        dispatch({ type: RetryActions.initiate_payment_failure });
    };
    const initiateRetryPaymentSuccess = (actionObject, paymentId, retryPaymentStatus, authorizationId) => {
        dispatch({
            type: RetryActions.initiate_payment_success,
            payload: { action: actionObject, paymentId, retryPaymentStatus, authorizationId },
        });
    };
    const processPaymentAuthorisationStart = () => {
        dispatch({ type: RetryActions.process_payment_authorisation_start });
    };
    const processPaymentAuthorisationFailure = () => {
        dispatch({ type: RetryActions.process_payment_authorisation_failure });
    };
    const processPaymentAuthorisationSuccess = (authorisationResult) => {
        dispatch({
            type: RetryActions.process_payment_authorisation_success,
            payload: authorisationResult,
        });
    };
    return (jsx(RetryDataContext.Provider, { value: {
            retryState: state,
            retrySuccessWithData,
            initiateRetryPaymentFailure,
            initiateRetryPaymentStart,
            initiateRetryPaymentSuccess,
            processPaymentAuthorisationStart,
            processPaymentAuthorisationFailure,
            processPaymentAuthorisationSuccess,
        }, children: children }));
};
const useRetryState = () => {
    return useContext(RetryDataContext);
};

export { RetryDataContext, RetryDataProvider, RetryDataProvider as default, useRetryState };
//# sourceMappingURL=RetryDataProvider.js.map
